
import React from 'react';
import { Castle, Mountain, Umbrella, DollarSign, Wifi, Plane, Train, Compass } from 'lucide-react';
import { QuizPreferences } from '@/types/quiz';

export const renderHighlights = (destination: any, preferences: QuizPreferences) => {
  const highlights: Array<{ text: string; icon: React.ReactNode; color: string }> = [];

  // Culture & Nature highlights
  if (preferences.interestFocus === 'culture' && destination.tourism_data?.unesco_sites) {
    highlights.push({
      text: 'UNESCO World Heritage Sites',
      icon: <Castle className="w-4 h-4" />,
      color: 'bg-purple-100 text-purple-800'
    });
  }
  if ((preferences.interestFocus === 'nature' || preferences.interestFocus === 'blend') && destination.nearby_natural_features?.length > 0) {
    highlights.push({
      text: 'Natural Attractions Nearby',
      icon: <Mountain className="w-4 h-4" />,
      color: 'bg-green-100 text-green-800'
    });
  }
  if (destination.has_beach) {
    highlights.push({
      text: 'Beach Destination',
      icon: <Umbrella className="w-4 h-4" />,
      color: 'bg-blue-100 text-blue-800'
    });
  }

  // Budget indicator
  const avgDailyBudget = destination.costs_infrastructure?.avg_daily_budget;
  if (avgDailyBudget) {
    let budgetText = '';
    let budgetColor = '';
    if (avgDailyBudget < 50) {
      budgetText = 'Budget-Friendly';
      budgetColor = 'bg-green-100 text-green-800';
    } else if (avgDailyBudget > 200) {
      budgetText = 'Luxury';
      budgetColor = 'bg-amber-100 text-amber-800';
    } else {
      budgetText = 'Moderate Cost';
      budgetColor = 'bg-blue-100 text-blue-800';
    }
    highlights.push({
      text: budgetText,
      icon: <DollarSign className="w-4 h-4" />,
      color: budgetColor
    });
  }

  // Connectivity
  if (preferences.connectivityNeeds === 'connected' && destination.costs_infrastructure?.internet_speed_avg > 50) {
    highlights.push({
      text: 'High-Speed Internet',
      icon: <Wifi className="w-4 h-4" />,
      color: 'bg-indigo-100 text-indigo-800'
    });
  }

  // Transportation
  if (preferences.journeyPreference === 'direct' && destination.transportation_data?.major_transport_hub) {
    highlights.push({
      text: 'Major Transport Hub',
      icon: <Plane className="w-4 h-4" />,
      color: 'bg-sky-100 text-sky-800'
    });
  } else if (preferences.journeyPreference === 'scenic' && destination.transportation_data?.inter_city_train_station) {
    highlights.push({
      text: 'Scenic Train Routes',
      icon: <Train className="w-4 h-4" />,
      color: 'bg-orange-100 text-orange-800'
    });
  }

  // Experience type
  if (preferences.experienceType === 'quirky' && destination.unique_experiences?.off_the_beaten_path) {
    highlights.push({
      text: 'Off the Beaten Path',
      icon: <Compass className="w-4 h-4" />,
      color: 'bg-rose-100 text-rose-800'
    });
  }

  return highlights.slice(0, 3); // Show top 3 most relevant highlights
};
